import * as Yup from "yup";
import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import gallary from "../../../../Utils/Images/Gallerywhite.png";
import CustomInput from "../../../../Components/input/CustomInput";
import { handleAddProduct } from "../../../../APIs/Function/Product/AddProduct";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GetProductCategory } from "../../../../APIs/Function/ProductCategory/GetProductCategory";

const AddProduct = () => {
  const validationSchema = Yup.object().shape({
    product_name: Yup.string().required("Product Name is required"),
    description: Yup.string().required("Description is required"),
    actual_price: Yup.string().required("Actual Price is required"),
    available_stock: Yup.string().required("Available Stock is required"),
    discount_price: Yup.string().required("Discounted Price is required"),
  });

  const [actualPriceError, setActualPriceError] = useState("");
  const [discountPriceError, setDiscountPriceError] = useState("");
  const [availableStockError, setAvailableStockError] = useState("");
  const [loading, setLoading] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [imagea, setimagea] = useState([]);
  const [category, setCategory] = useState([]);

  const navigate = useNavigate();

  const initialFormData = {
    product_name: "",
    description: "",
    actual_price: "",
    available_stock: "",
    discount_price: "",
    image: "",
    product_category: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const handleAddProductClick = async () => {
    const trimmedProductName = formData.product_name.trim();
    const trimmedDescription = formData.description.trim();

    const updatedFormData = {
      ...formData,
      product_name: trimmedProductName,
      description: trimmedDescription,
      image: imagea,
    };

    if (+formData.discount_price > +formData.actual_price) {
      alert("Discounted price should be less than actual price");
    } else if (
      Object.values(updatedFormData).some(
        (value) => typeof value === "number" && value < 0
      )
    ) {
      alert("Negative values are not allowed");
    } else {
      if (imagea.length) {
        try {
          await validationSchema.validate(updatedFormData, {
            abortEarly: false,
          });
          setLoading(true);
          await handleAddProduct(updatedFormData);
          setFormData(initialFormData);
          setPreviewImage([]);
          setLoading(false);
          alert("Product Added Successfully");
          navigate("/product");
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errorMessages = error.inner.map((err) => err.message);
            alert(errorMessages.join("\n"));
          } else {
            console.log(error);
            setLoading(false);
          }
        }
      } else {
        alert("Please Upload Image");
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const isNumericField = [
      "actual_price",
      "discount_price",
      "available_stock",
    ].includes(name);

    const parsedValue = isNumericField
      ? parseFloat(value).toFixed(2) // Limit to two decimal places
      : value;

    setFormData({
      ...formData,
      [name]: parsedValue,
    });

    if (isNumericField) {
      switch (name) {
        case "actual_price":
          if (parsedValue < 0) {
            setActualPriceError("Actual Price cannot be negative");
          } else {
            setActualPriceError("");
          }
          break;
        case "discount_price":
          if (parsedValue < 0) {
            setDiscountPriceError("Discounted Price cannot be negative");
          } else {
            setDiscountPriceError("");
          }
          break;
        case "available_stock":
          if (parsedValue < 0) {
            setAvailableStockError("Available Stock cannot be negative");
          } else {
            setAvailableStockError("");
          }
          break;
        default:
          break;
      }
    }
  };

  const getcategory = async () => {
    try {
      let res = await GetProductCategory();
      console.log(res.r)
      setCategory(res.r);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getcategory();
  }, []);
 console.log("object",formData)
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    const newImageArray = Array.from(selectedFiles);
    const updatedImageArray = [...imagea, ...newImageArray];

    setimagea(updatedImageArray);

    const objectURLs = [];
    for (let i = 0; i < updatedImageArray.length; i++) {
      const objectURL = URL.createObjectURL(updatedImageArray[i]);
      objectURLs.push(objectURL);
    }
    setPreviewImage(objectURLs);

    previewImage.forEach((objectURL) => URL.revokeObjectURL(objectURL));
  };

  const handleRemoveImage = (index) => {
    const updatedPreviewImage = [...previewImage];
    updatedPreviewImage.splice(index, 1);

    const imageArray = Array.from(imagea);

    const remainingFiles = imageArray.filter((_, i) => i !== index);

    setPreviewImage(updatedPreviewImage);
    setimagea(remainingFiles);

    const updatedFormData = { ...formData };
    updatedFormData.image = remainingFiles;
    setFormData(updatedFormData);
  };
  useEffect(() => {
    const updatedFormData = {
      ...formData,
      image: [previewImage[0]] || "",
    };
    setFormData(updatedFormData);
  }, [previewImage]);

  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/product"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Product
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleAddProductClick}
            disabled={loading}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center ",
        }}
      >
        {/* Form */}
        <Box
          sx={{
            mt: "10px",
            border: "1px solid #E8E8E8",
            width: "45%",
            boxSizing: "border-box",
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between ",
              alignItems: "center",
              boxSizing: "border-box",
              p: 1,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "20px",
                }}
              >
                Gallery
              </Typography>
            </Box>
            <Box>
              <label htmlFor="file-input">
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "#000000",
                    height: "50px",
                    width: "100%",
                    gap: "5px ",
                    alignItems: "center",
                    borderRadius: "5px",
                    p: 2,
                    boxSizing: "border-box",
                    cursor: "pointer",
                    transition: "transform 0.3s",
                    "&:hover": {
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontFamily: "inter",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "16px",
                    }}
                  >
                    Upload Image
                  </Typography>
                  <Box sx={{ width: "25px", height: "25px" }}>
                    <img width={"100%"} src={gallary} alt="gallary" />
                  </Box>
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-input"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              overflow: "auto",
              height: "500px",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            {previewImage
              ? previewImage.map((e, i) => (
                  <Box
                    key={i}
                    sx={{ position: "relative", width: "30%", height: "200px" }}
                  >
                    <img
                      style={{
                        borderRadius: "10px",
                        width: "100%",
                        height: "100%",
                      }}
                      src={e}
                      alt="preview"
                    />
                    <IconButton
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                      }}
                      onClick={() => handleRemoveImage(i)}
                    >
                      <HighlightOffIcon />
                    </IconButton>
                  </Box>
                ))
              : ""}
          </Box>
        </Box>
        <Box sx={{ width: "45%" }}>
          <Container maxWidth="sm" sx={{ mt: "10px" }}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    label="Product Name"
                    name="product_name"
                    value={formData.product_name}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth required>
                    <InputLabel
                      sx={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      Product Category
                    </InputLabel>
                    <Select
                      name="product_category" // Set a name for the Select component
                      value={formData.product_category} // Use the correct value from your form data
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          product_category: e.target.value,
                        })
                      }
                      sx={{ textAlign: "left" }}
                    >
                      {category?.map((e, i) => (
                        <MenuItem key={i} value={e.id}>
                          {e.category}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Actual Price"
                    name="actual_price"
                    type="number"
                    value={formData.actual_price}
                    onChange={handleInputChange}
                    fullWidth
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    required
                    error={actualPriceError !== ""}
                    helperText={actualPriceError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Discounted Price"
                    name="discount_price"
                    type="number"
                    value={formData.discount_price}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    error={discountPriceError !== ""}
                    helperText={discountPriceError}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Available Stock"
                    name="available_stock"
                    value={formData.available_stock}
                    type="number"
                    onChange={handleInputChange}
                    fullWidth
                    required
                    onKeyDown={(evt) =>
                      ["e", "E", "+", "-"].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    error={availableStockError !== ""}
                    helperText={availableStockError}
                  />
                </Grid>
              </Grid>
            </form>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default AddProduct;
